export const bikesTradeIn = '/bikes/trade-in';
export const bikesCompare = '/bikes/compare';
export const bikePlus = '/bike-plus';
export const bikes = '/bikes';
export const homeTrial = '/home-trial';
export const bikesClasses = '/bikes/classes';
export const bikesFinancing = '/bikes/financing';
export const tradeInTerms = '/trade-in-terms-and-conditions';
